import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  allGroups: [],
  loading: false,
  error: false,
};

const getAllGroupsRequest = createAction("getAllGroupsRequest");
const getAllGroupsSuccess = createAction("getAllGroupsSuccess");
const getAllGroupsFailure = createAction("getAllGroupsFailure");

export const groupsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getAllGroupsRequest, (state, action) => {
      state.loading = true;
    })
    .addCase(getAllGroupsSuccess, (state, action) => {
      state.loading = false;
      state.allGroups = action.payload?.groups;
    })
    .addCase(getAllGroupsFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
});
